import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import OpenPopupButton from '@/components/PopUps/OpenPopupButton.vue';
export default defineComponent({
    name: 'product-condition-info',
    components: { OpenPopupButton },
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })), { textBeforeCondition() {
            var _a;
            switch ((_a = this.currentProduct) === null || _a === void 0 ? void 0 : _a.condition.lowercase) {
                case 'wie neu':
                case 'sehr gut':
                case 'gut':
                case 'akzeptabel':
                    return 'gebraucht - ';
            }
            return '';
        } }),
});
